(() => {
  if (customElements.get('bdp-catalog')) return;
  customElements.define('bdp-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const grid = this.querySelector('[data-grid]');
      const films = [...this.querySelectorAll('[data-film]')];
      const filters = this.querySelector('[data-filters]');
      const search = this.querySelector('[data-search]');
      const sort = this.querySelector('[data-sort]');
      let active = 'all';
      const categories = new Map();
      films.forEach((film, index) => {
        film.originalIndex = index;
        film.categories = film.dataset.category.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
        film.dataset.category.split(',').forEach(label => { if (label.trim()) categories.set(label.trim().toLowerCase(), label.trim()); });
      });
      const addFilter = (value, label) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.filter = value; button.textContent = label;
        button.setAttribute('aria-pressed', 'false'); filters.append(button);
      };
      categories.forEach((label, value) => addFilter(value, label));
      addFilter('featured', 'Featured');
      const update = () => {
        const term = search.value.trim().toLowerCase();
        let count = 0;
        const ordered = [...films].sort((a,b) => {
          if (sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
          if (sort.value === 'year') return (parseInt(b.dataset.year,10)||0)-(parseInt(a.dataset.year,10)||0) || a.originalIndex-b.originalIndex;
          return Number(b.dataset.featured === 'true')-Number(a.dataset.featured === 'true') || a.originalIndex-b.originalIndex;
        });
        ordered.forEach(film => {
          film.hidden = !((active === 'all' || (active === 'featured' ? film.dataset.featured === 'true' : film.categories.includes(active))) && (film.dataset.title + ' ' + film.dataset.category).toLowerCase().includes(term));
          if (!film.hidden) count++;
          grid.append(film);
        });
        this.querySelector('[data-empty]').hidden = count > 0;
        this.querySelector('[data-count]').textContent = `${count} film${count === 1 ? '' : 's'} shown`;
      };
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-filter]'); if (!button) return;
        active = button.dataset.filter;
        filters.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        update();
      });
      search.addEventListener('input', update); sort.addEventListener('change', update);
      this.querySelector('[data-tools]').hidden = false; update();
    }
  });
})();
document.addEventListener('click', function (event) {
  const poster = event.target.closest('.bdp__art');
  if (!poster || event.ctrlKey || event.metaKey ||
      event.shiftKey || event.altKey) return;

  const film = poster.closest('[data-film]');
  const details = film?.querySelector('.bdp__details');

  if (!details ||
      poster.getAttribute('href') !== '#' + details.id) return;

  event.preventDefault();
  details.open = true;
});